/**
 * Management → Call Reports。
 * 打开页面打 STATSIG.COMMON.VIEW，value=mgmt_call_reports。
 *
 * 正在用：
 * - Generate Report（选季度 / 年 / 州后出预览）
 * - 历史表：查看、导出 Excel、删除
 * - 预览：Save and exit、Export（Save 记 INSERT）
 * - 返回未保存时弹窗 Save report
 *
 * 已不算：Export as XML、Save edit、切州/分类、改单元格、分页、
 * Exit without saving、点 Back 本身。
 */
export enum MgmtCallReportsEvent {
    /** 点 Generate Report 出预览 */
    GENERATE = 'CALL_REPORTS_GENERATE',
    /** 历史表点查看 */
    REPORT_OPEN = 'CALL_REPORTS_REPORT_OPEN',
    /**
     * 导出 Excel。
     * 属性 source=history|review
     */
    EXPORT = 'CALL_REPORTS_EXPORT',
    /** Save and exit，或返回弹窗里的 Save report（新建落库） */
    INSERT = 'CALL_REPORTS_INSERT',
    /** 删除一份历史报告 */
    DELETE = 'CALL_REPORTS_DELETE',
}
